import { useEffect, useState } from 'react';

import { CookieAccessor } from '../../Customers/UserProfile/Components/CookiesConsent/CookieAccessor';

export const useBankIdSession = (rxSessionCookieName: string, rxSessionValidityCookieName: string, rxSessionExpirationTimeCookieName: string) => {
    const SESSION_REFRESH_SECONDS = 5;

    const [hasSession, setHasSession] = useState(false);
    const [isSessionActive, setIsSessionActive] = useState(false);
    const [hasExpiryDate, setHasExpiryDate] = useState(false);

    useEffect(() => {
        updateSessionData();

        const timer = setInterval(updateSessionData, SESSION_REFRESH_SECONDS * 1000);
        return () => clearInterval(timer);
    }, []);

    const updateSessionData = () => {
        setHasSession(!!CookieAccessor.getCookie(rxSessionCookieName));
        setIsSessionActive(!!CookieAccessor.getCookie(rxSessionValidityCookieName));
        setHasExpiryDate(!!CookieAccessor.getCookie(rxSessionExpirationTimeCookieName));
    };

    return { isValid: hasSession && isSessionActive && hasExpiryDate };
};
